import React, { Component } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

class Filip extends Component {
  render() {
    return (
      <Container>
        <Row className="p-2"></Row>
        <Row>
          <Col lg={7}>
            <div className="mb-5 mr-5  embed-responsive embed-responsive-16by9 ">
              <iframe
                title="embedsPage"
                className=" embed-responsive-item"
                src="https://player.vimeo.com/video/209269766?autoplay=1&color=ffffff&title=0&byline=0&portrait=0"
                allow=" fullscreen"
                allowfullscreen
              ></iframe>
            </div>
          </Col>

          <Col className="ml-3" lg={4}>
            <Row>
              <h3 className="robotomono font-weight-bold ">FILIP</h3>
              <h6 className="ml-4  robotomono font-weight-bold d-flex align-items-end">
                11 min
              </h6>
            </Row>
            <Row className="mb-5">
              <h6 className="robotomono font-weight-bold sticky-top">
                Writer / Director / Editor
              </h6>
            </Row>

            <Row className="montserrat mt-5  mr-1">
              <p>
                Seven-year-old Filip admires his sixteen-year-old brother
                Sebastian most of all. One evening, Filip sees something
                unexpected happen between Sebastian and Sebastian’s best friend.
                He doesn’t know how to handle it.
              </p>
            </Row>
          </Col>
        </Row>

        <Row className="p-5"></Row>
      </Container>
    );
  }
}

export default Filip;
